import React, { Dispatch } from 'react';
import { Dialog, SxProps } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../redux/store';
import { closeDocumentDetailsDialog } from '../../../redux/project/documents/sliceProjectDocumentDetails';
import DocumentDetailsViewContainer from '../../Views/DocumentDetailsView/DocumentDetailsViewContainer';

/** Styles for Dialog's component. */
const dialogSx: SxProps = {
    '& .MuiDialog-paper': {
        width: '90%',
        height: '80%',
        minWidth: '350px',
        maxWidth: 'none',
        padding: 2,
        paddingTop: 4,
    },
};

/** Styles for expanded Dialog's component. */
const expandedDialogSx: SxProps = {
    '& .MuiDialog-paper': {
        overflow: 'hidden',
        padding: 2,
        paddingTop: 4,
    },
};

/**
 * Dialog Component that provides document details.
 */
export default () => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Access relevant state variables from the redux store. */
    const { isDialogExpanded, isDialogOpen } = useSelector(
        (store: IAppReduxStore) => store.projectDocumentDetails,
    );

    /**
     * Closes the document's details Dialog.
     */
    const handleCloseDocumentdetailsDialog = () => {
        dispatch(closeDocumentDetailsDialog(true));
    };

    return (
        <Dialog
            fullScreen={isDialogExpanded}
            onClose={handleCloseDocumentdetailsDialog}
            open={isDialogOpen}
            sx={isDialogExpanded ? expandedDialogSx : dialogSx}
        >
            <DocumentDetailsViewContainer isDialog={true} />
        </Dialog>
    );
};
